import { externalCatalogs } from "./external-catalogs-de.i18n";

export const de = {
  externalCatalogs,
};
